import { render, staticRenderFns } from "./TituloCarrinho.vue?vue&type=template&id=1ee5ab6b&scoped=true"
import script from "./TituloCarrinho.vue?vue&type=script&lang=js"
export * from "./TituloCarrinho.vue?vue&type=script&lang=js"
import style0 from "./TituloCarrinho.vue?vue&type=style&index=0&id=1ee5ab6b&prod&scoped=true&lang=css"
import style1 from "./TituloCarrinho.vue?vue&type=style&index=1&id=1ee5ab6b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ee5ab6b",
  null
  
)

export default component.exports